import {BottomSheet, SignInOrSignUp} from "@/components";
import {StickyHeader, YStack} from "@chayka/ui";

export const BookingPageUnauthorized = () => {
  return (
    <BottomSheet fullHeight isOpen={true}>
      <StickyHeader className="-mt-6 -top-6!" title="Бронирование" />
      <YStack className="flex-1 justify-center items-stretch pt-[25vh] gap-6">
        <h1 className="self-center text-3xl font-light">Добро пожаловать!</h1>
        <div className="self-center text-sm">Вы ещё не вошли в свой аккаунт</div>
        <SignInOrSignUp />
      </YStack>
    </BottomSheet>
  );
};
